import styled from '@emotion/styled';

import { useCapabilityValue } from '../../../store/devices/useCapabilityValue';

import { theme } from '../../../theme/theme';

import { IconButton } from '../../buttons/IconButton';

import speaker_next from '../images/media/speaker_next.svg';
import speaker_prev from '../images/media/speaker_prev.svg';
import speaker_playing from '../images/media/speaker_play.svg';
import speaker_pause from '../images/media/speaker_pause.svg';
import speaker_repeat from '../images/media/speaker_repeat.svg';
import speaker_repeat_list from '../images/media/speaker_repeat_list.svg';
import speaker_shuffle from '../images/media/speaker_shuffle.svg';
import { useIsRTL } from '../../../hooks/useIsRTL';

export function MediaControls(props) {
  const isRTL = useIsRTL();
  const [speakerShuffleValue, setSpeakerShuffleValue] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_shuffle',
  });
  const [, setSpeakerPrevValue] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_prev',
  });
  const [speakerPlayingValue, setSpeakerPlayingValue] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_playing',
  });
  const [, setSpeakerNextValue] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: 'speaker_next',
  });
  const [speakerRepeatValue, setSpeakerRepeatValue, speakerRepeatCapabilityObj] =
    useCapabilityValue({
      deviceId: props.deviceId,
      capabilityId: 'speaker_repeat',
    });

  return (
    <MediaControlsContainer>
      {props.component.capabilities.includes('speaker_shuffle') && (
        <IconButton
          size="24px"
          color={speakerShuffleValue ? 'rgba(18, 193, 255, 1)' : theme.color.white}
          url={speaker_shuffle}
          onPress={() => {
            setSpeakerShuffleValue(!speakerShuffleValue)
              .then(() => {})
              .catch(() => {});
          }}
        />
      )}

      {props.component.capabilities.includes('speaker_prev') && (
        <IconButton
          size="24px"
          color={theme.color.white}
          url={isRTL ? speaker_next : speaker_prev}
          onPress={() => {
            setSpeakerPrevValue(true)
              .then(() => {})
              .catch((error) => {});
          }}
        />
      )}

      {props.component.capabilities.includes('speaker_playing') && (
        <IconButton
          size="56px"
          color={theme.color.white}
          url={speakerPlayingValue ? speaker_pause : speaker_playing}
          onPress={() => {
            setSpeakerPlayingValue(!speakerPlayingValue)
              .then(() => {})
              .catch(() => {});
          }}
        />
      )}

      {props.component.capabilities.includes('speaker_next') && (
        <IconButton
          size="24px"
          color={theme.color.white}
          url={isRTL ? speaker_prev : speaker_next}
          onPress={() => {
            setSpeakerNextValue(true)
              .then(() => {})
              .catch((error) => {});
          }}
        />
      )}

      {props.component.capabilities.includes('speaker_repeat') && (
        <IconButton
          size="24px"
          url={
            {
              none: speaker_repeat,
              track: speaker_repeat,
              playlist: speaker_repeat_list,
            }[speakerRepeatValue] ?? speaker_repeat
          }
          color={
            speakerRepeatValue !== 'none' && speakerRepeatValue !== null
              ? 'rgba(18, 193, 255, 1)'
              : theme.color.white
          }
          onPress={() => {
            const values = speakerRepeatCapabilityObj.values;
            const currentIndex = values.findIndex((value) => value.id === speakerRepeatValue);
            const nextValue = values[(currentIndex + 1) % values.length].id;

            setSpeakerRepeatValue(nextValue)
              .then(() => {})
              .catch((error) => {});
          }}
        />
      )}
    </MediaControlsContainer>
  );
}

const MediaControlsContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 20px;
  margin-top: 42px;
`;
